import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { InlineWidget } from "react-calendly";
import { useTranslation } from "react-i18next";
import {BookCallModal} from "../common/BooKCallModal";

const Contact = () => {
    const { t } = useTranslation();
    const [calendlyEnabled, setCalendlyEnabled] = useState(false);

    return (
        <section
            id="contact"
            className="py-5 bg-light"
            aria-labelledby="contact-heading"
        >
            <Row className="justify-content-center px-3">
                <Col lg={8}>
                    <div className="bg-white rounded text-center p-5 border-0 shadow">
                        <h2 id="contact-heading"  className="fw-bold mb-3">
                            {t("pages.home.contact.title")}
                        </h2>
                        <p className="text-muted lead mb-4">
                            {t("pages.home.contact.subTitle") ?? "Have questions or need help setting up DMARC? Let’s talk."}
                        </p>

                            <button
                                className="btn btn-lg btn-dark px-4 py-2"
                                style={{ fontSize: "1.2rem" }}
                                onClick={() => setCalendlyEnabled(true)}
                            >
                                {t("pages.home.contact.buttonCta")}
                            </button>
                    </div>
                </Col>
            </Row>
            <BookCallModal show={calendlyEnabled} handleClose={() => setCalendlyEnabled(false)}/>

        </section>
    );
};

export default Contact;
